/**
 * Query parameter used to determine if a user is in the
 * 'Email Verification On Web' flow during registration.
 * Lives here to ensure consistency across different repos.
 */
export const EMAIL_VERIFICATION_ON_WEB_QP = 'evow';
/**
 * Query parameter keys used by WebSignup
 */
export var WebSignupQueryParam;
(function (WebSignupQueryParam) {
    WebSignupQueryParam["flow"] = "flow";
    WebSignupQueryParam["code"] = "code";
    WebSignupQueryParam["refId"] = "refId";
    WebSignupQueryParam["referral"] = "referral";
    WebSignupQueryParam["ignoreConfirmation"] = "ignoreConfirmation";
    WebSignupQueryParam["measuringDevice"] = "measuringDevice";
    /**
     * Passed by Impact in the URL
     */
    WebSignupQueryParam["irclickid"] = "irclickid";
    /**
     * Fertility goal
     */
    WebSignupQueryParam["fg"] = "fg";
    WebSignupQueryParam["payment_intent"] = "payment_intent";
    WebSignupQueryParam["payment_intent_client_secret"] = "payment_intent_client_secret";
    WebSignupQueryParam["redirect_status"] = "redirect_status";
    /**
     * Clearblue offer
     */
    WebSignupQueryParam["cbo"] = "cbo";
    /**
     * The chosen insurance provider option (InsuranceProviderOption enum)
     */
    WebSignupQueryParam["ip"] = "ip";
    /**
     * The chosen insurance provider variant
     *
     * For BlueCross BlueShield, this will likely be an item in the list
     * of BCBS variants but can be any inputted string.
     * For other providers, this will likely be an item in the list of other providers,
     * but can also be any inputted string. Just intended for analytics.
     */
    WebSignupQueryParam["ipv"] = "ipv";
    /**
     * Added by the apple auth sign in flow
     */
    WebSignupQueryParam["appleAuth"] = "appleAuth";
    /**
     * Owns device. Used to determine if the owns the measuring device for flows starting on the plans page.
     * Eg. Email verification on web flow
     */
    WebSignupQueryParam["od"] = "od";
    /**
     * Plan
     * The plan which the user has selected.
     * Used in the flow where the user is redirected to WebSignup from the app for payment.
     */
    WebSignupQueryParam["pl"] = "pl";
    /**
     * Passed by Snapchat ads in the URL
     */
    WebSignupQueryParam["ScCid"] = "ScCid";
    /**
     * Passed by Meta ads in the URL
     */
    WebSignupQueryParam["fbclid"] = "fbclid";
    /**
     * Passed by TikTok ads in the URL
     */
    WebSignupQueryParam["ttclid"] = "ttclid";
})(WebSignupQueryParam || (WebSignupQueryParam = {}));
/**
 * Parameters from CAPI platforms and other sources of traffic that identify
 * the click that brought the user here.
 *
 * These should be saved so that we can access these after navigation and
 * pass them to the relevant platform
 */
export const clickIdParameters = [
    WebSignupQueryParam.ScCid,
    WebSignupQueryParam.irclickid,
    WebSignupQueryParam.fbclid,
    WebSignupQueryParam.ttclid,
];
